import jsPDF from "jspdf";
import 'jspdf-autotable';
import conv from "@/helpers/conversores.js";
import func from "@/helpers/funciones";

export default{
    exportToPdfDistribution(distribucion, estadisticas, turno){
        //Se genera el documento
        var doc = new jsPDF('p','pt');

        //Se inserta el logo
        var img = new Image();
        img.src = require("@/assets/logos/Logo.png");
        doc.addImage(img, "png", 0, 7, 142, 70);

        //Se inserta titulo
        const date = conv.formatFecha(Date.now());
        doc.text('Distribucion de habitacion '+turno, 190, 90);

        //Se inserta fecha
        doc.setFontSize(8);
        doc.text(conv.formatFecha(Date.now()), 58, 85);

        
        doc.autoTable({
            head: [['Ocupada', 'Reservada', 'Libre', 'No Disp.', 'Cuarentena','Ocupada Día','Ocupada Noche','Total']],
            body: [[estadisticas.ocupada, estadisticas.reservada, estadisticas.libre, 
                    estadisticas.no_disponible, estadisticas.cuarentena, estadisticas.dia,
                    estadisticas.noche, estadisticas.total]],
            headerStyle:{fillColor: [139, 0, 0], fontSize: 8},
            didDrawPage: function (data) {
                doc.text(
                    "Estadisticas",
                    data.settings.margin.left,
                    data.settings.margin.top - 5
                    );     
            },
            margin: { top: 120 },
            theme: "grid",
            columnStyles: {
                0: { cellWidth: 64 }, // Ancho para la columna 'Ocupada'
                1: { cellWidth: 64 }, // Ancho para la columna 'Reservada'
                2: { cellWidth: 64 }, // Ancho para la columna 'Libre'
                3: { cellWidth: 64 }, // Ancho para la columna 'No Disponible'
                4: { cellWidth: 64 }, // Ancho para la columna 'Cuarentena'
                5: { cellWidth: 64 }, // Ancho para la columna 'Ocupada Día'
                6: { cellWidth: 64 }, // Ancho para la columna 'Ocupada Noche'
                7: { cellWidth: 64 }, // Ancho para la columna 'Total'
            }
        });

        var columns = [
            {title: "Hab", dataKey: "room.numero_hab"},
            {title: "Cama", dataKey: "lado"},
            {title: "Estado", dataKey: "estadoAB"},
            {title: "Nombre", dataKey: "cliente.name"},
            {title: "Apellido Paterno", dataKey: "cliente.f_lastname"},
            {title: "Apellido Materno", dataKey: "cliente.m_lastname"},
            {title: "Turno", dataKey: "cliente.turno"},
            {title: "Grupo", dataKey: "cliente.grupo"},   
        ];
        var distribucionFormatted

        if(turno =='AB'){
            distribucionFormatted = distribucion.map(function(item) {
                return {
                    "room.numero_hab": item.room.numero_hab,
                    "lado": item.lado,
                    "estadoAB": item.estadoAB,
                    "cliente.name": item.cliente?.name || '',
                    "cliente.f_lastname": item.cliente?.f_lastname || '',
                    "cliente.m_lastname": item.cliente?.m_lastname || '',
                    "cliente.turno": item.cliente?.turno || '',
                    "cliente.grupo": item.cliente?.grupo || ''
                };
            });
        }else{
            distribucionFormatted = distribucion.map(function(item) {
                return {
                    "room.numero_hab": item.room.numero_hab,
                    "lado": item.lado,
                    "estadoAB": item.estadoCD,
                    "cliente.name": item.cliente?.name || '',
                    "cliente.f_lastname": item.cliente?.f_lastname || '',
                    "cliente.m_lastname": item.cliente?.m_lastname || '',
                    "cliente.turno": item.cliente?.turno || '',
                    "cliente.grupo": item.cliente?.grupo || ''
                };
            });
        }
    
        doc.autoTable(columns, distribucionFormatted, {margin: {top: 60},});
        doc.save('Distribucion_habitaciones_' + date);

    },
    exportToPdfCliente(cliente){
        console.log(cliente);
        //Se genera el documento
        var doc = new jsPDF('p','pt');

        //Se inserta el logo
        var img = new Image();
        img.src = require("@/assets/logos/Logo.png");
        doc.addImage(img, "png", 0, 7, 142, 70);

        //Se inserta titulo
        const date = conv.formatFecha(Date.now());
        doc.text('Lista de clientes', 230, 90);

        //Se inserta fecha
        doc.setFontSize(8);
        doc.text(conv.formatFecha(Date.now()), 58, 85);

        var columns = [
            {title: "Nombre", dataKey: "nombre"},
            {title: "Apellido Paterno", dataKey: "f_lastname"},
            {title: "Apellido Materno", dataKey: "m_lastname"},
            {title: "Grupo", dataKey: "grupo"},  
            {title: "Cargo", dataKey: "cargo"},
        ];
        var lista_clientes = cliente.map(function(item) {
            return {
                "nombre": item.name,
                "f_lastname": item.f_lastname,
                "m_lastname": item.m_lastname || '',
                "grupo": item.grupo || '',
                "cargo": item.cargo || ''
            };
        });

        doc.autoTable(columns, lista_clientes, {margin: {top: 120},});
        doc.save('Lista_clientes_' + date);

    },
    exportToPdfPreciosKiosko(lista, lista_proveedores) {

        // Documento vertical
        var doc = new jsPDF('p', 'pt');

        // Logo
        var img = new Image();
        img.src = require("@/assets/logos/Logo.png");
        doc.addImage(img, "png", 0, 7, 142, 70);

        // Fecha
        const date = conv.formatFecha(Date.now());

        // Título
        doc.setFontSize(14);
        doc.text('Precios Kiosko', 250, 70);

        // Fecha
        doc.setFontSize(8);
        doc.text(date, 58, 85);

        var columns = [
            {
                title: "Nombre",
                dataKey: "nombre"
            },
            {
                title: "Proveedor",
                dataKey: "proveedor"
            },
            {
                title: "Precio Neto",
                dataKey: "precio_neto"
            },
            {
                title: "Precio Bruto",
                dataKey: "precio_bruto"
            },
            {
                title: "Sug. 30%",
                dataKey: "precio_30"
            },
            {
                title: "Sug. 40%",
                dataKey: "precio_40"
            },
            {
                title: "Sug. 50%",
                dataKey: "precio_50"
            }
        ];

        var tabla = lista.map(function(item) {

            const proveedorPrincipal = item.providers?.[0];

            const proveedorEncontrado = lista_proveedores.find(function(p) {
                return p._id === proveedorPrincipal?.provider;
            });

            const precioNeto = Number(proveedorPrincipal?.precio_neto ?? 0);
            const precioBruto = Number(proveedorPrincipal?.precio_bruto ?? 0);

            return {
                nombre: item.nombre,

                proveedor: proveedorEncontrado
                    ? proveedorEncontrado.nombre
                    : "Sin proveedor",

                precio_neto: precioNeto,

                precio_bruto: precioBruto,

                precio_30: Math.round(precioBruto * 1.30),

                precio_40: Math.round(precioBruto * 1.40),

                precio_50: Math.round(precioBruto * 1.50)
            };
        });

        doc.autoTable(columns, tabla, {
            margin: {
                top: 100,
                left: 8,
                right: 8
            },

            tableWidth: 'auto',

            styles: {
                fontSize: 6.5,
                cellPadding: 2,
                valign: 'middle',
                overflow: 'linebreak'
            },

            headerStyles: {
                fontSize: 6.5,
                halign: 'center',
                valign: 'middle'
            },

            columnStyles: {
                nombre: {
                    cellWidth: 150
                },

                proveedor: {
                    cellWidth: 75
                },

                precio_neto: {
                    cellWidth: 65,
                    halign: 'center'
                },

                precio_bruto: {
                    cellWidth: 65,
                    halign: 'center'
                },

                precio_30: {
                    cellWidth: 65,
                    halign: 'center'
                },

                precio_40: {
                    cellWidth: 65,
                    halign: 'center'
                },

                precio_50: {
                    cellWidth: 65,
                    halign: 'center'
                }
            }
        });

        doc.save(
            'Precios_Kiosko_' +
            date +
            '.pdf'
        );
    },
    exportToPdfMaquinas(maquina, tipo){
        //Se genera el documento
        var doc = new jsPDF('p','pt');

        //Se inserta el logo
        var img = new Image();
        img.src = require("@/assets/logos/Logo.png");
        doc.addImage(img, "png", 0, 7, 142, 70);

        //Se inserta titulo
        const date = conv.formatFecha(Date.now());
        doc.text('Lista de maquina por Tipo: '+ tipo, 230, 90);

        //Se inserta fecha
        doc.setFontSize(8);
        doc.text(conv.formatFecha(Date.now()), 58, 85);

       var columns = [
            {title: "Código", dataKey: "codigo"},
            {title: "Marca", dataKey: "marca"},
            {title: "Modelo", dataKey: "modelo"},  
            {title: "Capacidad", dataKey: "capacidad"},
            {title: "Fecha Mantención", dataKey: "fechaMantencion"},
            {title: "Próxima Mantención", dataKey: "proximaMantencion"},
            {title: "Frecuencia (meses)", dataKey: "frecuenciaMantencionMeses"}
        ];
        var lista_maquinas = maquina.map(function(item) {
            return {
                "tipoEquipo": item.tipoEquipo,
                "codigo": item.codigo,
                "marca": item.marca || '',
                "modelo": item.modelo || '',
                "capacidad": item.capacidad? `${item.capacidad} ${item.unidadCapacidad || ''}`.trim() : '',
                "fechaMantencion": item.fechaMantencion ? conv.formatFecha(item.fechaMantencion) : '',
                "proximaMantencion": item.proximaMantencion ? conv.formatFecha(item.proximaMantencion) : '',
                "frecuenciaMantencionMeses": item.frecuenciaMantencionMeses,
            };
        });

        doc.autoTable(columns, lista_maquinas, {margin: {top: 120},});
        doc.save('Lista_maquinas_' + tipo + '_' +  date);

    },
    exportToPdfInsumoporTipo(insumos, tipo_seleccionado){
        console.log(insumos);
        //Se genera el documento
        var doc = new jsPDF('p','pt');

        //Se inserta el logo
        var img = new Image();
        img.src = require("@/assets/logos/Logo.png");
        doc.addImage(img, "png", 0, 7, 142, 70);

        //Se inserta titulo
        const date = conv.formatFecha(Date.now());
        doc.text('Lista de Insumos de tipo: ' + tipo_seleccionado.tipo, 200, 90);

        var columns = [
            {title: "Nombre", dataKey: "nombre"},
            {title: "Unidad Venta", dataKey: "unidad_venta"},
            {title: "Unidad Pedido", dataKey: "unidad_pedido"},
            {title: "Cantidad Unidad", dataKey: "cantidad_unidad"},  
            {title: "Cantidad Máxima", dataKey: "cap_max"},
            {title: "Consumo Semanal", dataKey: "cap_min"},
            {title: "Periodo Vencimiento (Semanas)", dataKey: "periodo_vencimiento"},
            {title: "Stock (Actual)", dataKey: "actual"},
            {title: "Proveedores", dataKey: "proveedores"}
        ];
        var lista_insumos = insumos.map(function(item) {
            const proveedores = (item.providers && item.providers.length)
                ? item.providers
                    .slice(0, 2)
                    .map(p => p.provider?.nombre || 'Sin nombre')
                    .join(', ')
                : 'Sin proveedores';
            return {
                "nombre": item.nombre,
                "unidad_venta": item.unidad_venta,
                "unidad_pedido": item.unidad_pedido,
                "cantidad_unidad": item.cantidad_unidad ,
                "cap_max": item.cap_max ,
                "cap_min": item.cap_min,
                "periodo_vencimiento": item.periodo_vencimiento,
                "actual": item.actual,
                "proveedores": proveedores
            };
        });

        doc.autoTable(columns, lista_insumos, {margin: { top: 120 }, columnStyles: {periodo_vencimiento: { halign: 'center' }},headStyles: { halign: 'center'}});
        doc.save('Lista_insumos_' + date);

    },
    exportToPdfPersonal(personal){
        const personalCopia = [...personal];
        personalCopia.shift();
        personalCopia.sort(func.ordenarInicioContrato);
        //Se genera el documento
        var doc = new jsPDF('p','pt');
    
        //Se inserta el logo
        var img = new Image();
        img.src = require("@/assets/logos/Logo.png");
        doc.addImage(img, "png", 0, 7, 142, 70);
    
        //Se inserta titulo
        const date = conv.formatFecha(Date.now());
        doc.text('Listado contrato Personal', 230, 90);
    
        //Se inserta fecha
        doc.setFontSize(8);
        doc.text(conv.formatFecha(Date.now()), 58, 85);
    
        var columns = [
            {title: "Nombre", dataKey: "name"},
            {title: "Apellido Paterno", dataKey: "f_lastname"},
            {title: "Apellido Materno", dataKey: "m_lastname"},
            {title: "Inicio Contrato", dataKey: "fecha_Inicio"},  
            {title: "Fin Contrato", dataKey: "fecha_Final"},
            {title: "Años en la empresa", dataKey: "years_in_company"} // Nueva columna
        ];
        var lista_personal = personalCopia.map(function(item) {
            // Calcular años en la empresa
            const startDate = new Date(item.fecha_Inicio);
            const currentDate = new Date();
            const diffTime = Math.abs(currentDate - startDate);
            const diffYears = diffTime / (1000 * 60 * 60 * 24 * 365); // Convertir de milisegundos a años
            const yearsInCompany = Math.trunc(diffYears*10) /10;
    
            return {
                "name": item.name,
                "f_lastname": item.f_lastname,
                "m_lastname": item.m_lastname || '',
                "fecha_Inicio": conv.formatFecha(item.fecha_Inicio) || '',
                "fecha_Final": item.fecha_Final ? conv.formatFecha(item.fecha_Final) : 'Indefinido',
                "years_in_company": yearsInCompany // Años en la empresa
            };
        });
    
        doc.autoTable(columns, lista_personal, {margin: {top: 120}});
        doc.save('Lista_personal_' + date);
    },
    exportToPdfPersonalBirthday(personal){
        const personalCopia = [...personal];
        personalCopia.sort(func.compararFechas);
        //Se genera el documento
        var doc = new jsPDF('p','pt');

        //Se inserta el logo
        var img = new Image();
        img.src = require("@/assets/logos/Logo.png");
        doc.addImage(img, "png", 0, 7, 142, 70);

        //Se inserta titulo
        const date = conv.formatFecha(Date.now());
        doc.text('Cumpleaños Personal', 230, 90);

        //Se inserta fecha
        doc.setFontSize(8);
        doc.text(conv.formatFecha(Date.now()), 58, 85);

        var columns = [
            {title: "Nombre", dataKey: "name"},
            {title: "Apellido Paterno", dataKey: "f_lastname"},
            {title: "Apellido Materno", dataKey: "m_lastname"},
            {title: "Fecha Nacimiento", dataKey: "fecha_Nac"},  
        ];
        var lista_personal = personalCopia.map(function(item) {
            return {
                "name": item.name,
                "f_lastname": item.f_lastname,
                "m_lastname": item.m_lastname || '',
                "fecha_Nac": conv.formatFecha(item.fecha_Nac) || '',
            };
        });

        doc.autoTable(columns, lista_personal, {margin: {top: 120},});
        doc.save('Lista_personal_' + date);

    },
    exportToPdfPedidos(lista, nombre_proveedor){
        //Se genera el documento
        var doc = new jsPDF('p','pt');

        //Se inserta el logo
        var img = new Image();
        img.src = require("@/assets/logos/Logo.png");
        doc.addImage(img, "png", 0, 7, 142, 70);

        //Se inserta titulo
        const date = conv.formatFecha(Date.now());
        doc.text('Pedidos '+nombre_proveedor, 220, 90);

        //Se inserta fecha
        doc.setFontSize(8);
        doc.text(conv.formatFecha(Date.now()), 58, 85);

        var columns = [
            {title: "Insumo", dataKey: "nombre"},
            {title: "Tipo", dataKey: "tipo"},
            {title: "Pedir", dataKey: "pedir"},
            {title: "Unidad", dataKey: "unidad_pedido"},
            {title: "Formato", dataKey: "formato"}
        ];
        var tabla = lista
            .filter(function(item) {
                return item.pedir > 0;
            })
            .map(function(item) {
                return {
                    "nombre": item.nombre,
                    "tipo": item.tipo,
                    "pedir": item.pedir,
                    "unidad_pedido": item.unidad_pedido,
                    "formato": item.formato
                };
            });
        doc.autoTable(columns, tabla, {margin: {top: 100},});
        doc.save('Pedidos_' + nombre_proveedor + '_' + date);
    },
    exportToPdfPedidosJefatura(lista, nombre_proveedor) {

        // Documento horizontal
        var doc = new jsPDF('l', 'pt');

        // Logo
        var img = new Image();
        img.src = require("@/assets/logos/Logo.png");
        doc.addImage(img, "png", 0, 7, 142, 70);

        // Fecha
        const date = conv.formatFecha(Date.now());

        doc.setFontSize(14);
        doc.text('Revisión de Pedidos - ' + nombre_proveedor, 300, 55);

        doc.setFontSize(8);
        doc.text(date, 58, 85);

        var columns = [
            {
                title: "Nombre",
                dataKey: "nombre"
            },
            {
                title: "Unidad Pedido",
                dataKey: "unidad_pedido"
            },
            {
                title: "Cantidad Unidad",
                dataKey: "cantidad_unidad"
            },
            {
                title: "Cap. Máxima",
                dataKey: "cap_max"
            },
            {
                title: "Consumo Semanal",
                dataKey: "cap_min"
            },
            {
                title: "Periodo Vencimiento",
                dataKey: "periodo_vencimiento"
            },
            {
                title: "Stock Actual",
                dataKey: "actual"
            },
            {
                title: "Alcanza para",
                dataKey: "alcanza_para"
            },
            {
                title: "Pedir",
                dataKey: "pedir"
            }
        ];

        var tabla = lista.map(function(item) {

            let alcanzaPara = '';

            if (item.cap_min && Number(item.cap_min) !== 0) {
                alcanzaPara = (
                    Number(item.actual) / Number(item.cap_min)
                ).toFixed(1);
            }

            return {
                nombre: item.nombre,
                unidad_pedido: item.unidad_pedido,
                cantidad_unidad: item.cantidad_unidad,
                cap_max: item.cap_max,
                cap_min: item.cap_min,
                periodo_vencimiento: item.periodo_vencimiento,
                actual: item.actual,
                alcanza_para: alcanzaPara,

                // Pedir + pedido sugerido en la misma celda
                pedir:
                    'Pedir: ' + (item.pedir ?? 0) +
                    '\nSugerido: ' + (item.pedido_sugerido ?? 0)
            };
        });

        doc.autoTable(columns, tabla, {
            margin: {
                top: 100,
                left: 10,
                right: 10
            },

            tableWidth: 'auto',

            styles: {
                fontSize: 7,
                cellPadding: 4,
                valign: 'middle',
                overflow: 'linebreak'
            },

            headerStyles: {
                fontSize: 7,
                halign: 'center',
                valign: 'middle'
            },

            columnStyles: {
                nombre: {
                    cellWidth: 120
                },

                unidad_pedido: {
                    cellWidth: 75,
                    halign: 'center'
                },

                cantidad_unidad: {
                    cellWidth: 75,
                    halign: 'center'
                },

                cap_max: {
                    cellWidth: 70,
                    halign: 'center'
                },

                cap_min: {
                    cellWidth: 80,
                    halign: 'center'
                },

                periodo_vencimiento: {
                    cellWidth: 90,
                    halign: 'center'
                },

                actual: {
                    cellWidth: 70,
                    halign: 'center'
                },

                alcanza_para: {
                    cellWidth: 70,
                    halign: 'center'
                },

                pedir: {
                    cellWidth: 105,
                    halign: 'center'
                }
            }
        });

        doc.save(
            'Revision_Pedidos_' +
            nombre_proveedor +
            '_' +
            date +
            '.pdf'
        );
    },

    exportToPdfTipoInsumo(insumos, nombre_tipo){
        //Se genera el documento
        var doc = new jsPDF('p','pt');

        //Se inserta el logo
        var img = new Image();
        img.src = require("@/assets/logos/Logo.png");
        doc.addImage(img, "png", 0, 7, 142, 70);

        //Se inserta titulo
        const date = conv.formatFecha(Date.now());
        doc.text('Informe: '+nombre_tipo, 220, 90);

        //Se inserta fecha
        doc.setFontSize(8);
        doc.text(conv.formatFecha(Date.now()), 58, 85);

        var columns = [
            {title: "Insumo", dataKey: "insumo"},
            {title: "Unidad", dataKey: "unidad_venta"},
            {title: "Proveedor", dataKey: "proveedor"},
            {title: "Precio Neto", dataKey: "precio_neto"},
            {title: "Pedido", dataKey: "unidad_pedido"},
            {title: "Factor", dataKey: "cantidad_unidad"},
            {title: "Stock", dataKey: "actual"},
            {title: "Inventario", dataKey: "inventario"}
        ];
        var tabla = insumos
            .map(function(item) {
                const inventario = (item.actual || 0) * (item.providers?.[0]?.precio_neto || 0) * (item.cantidad_unidad || 0);
                return {
                    "insumo": item.nombre,
                    "unidad_venta": item.unidad_venta,
                    "proveedor": item.providers[0].provider.nombre,
                    "precio_neto": item.providers[0].precio_neto,
                    "unidad_pedido": item.unidad_pedido,
                    "cantidad_unidad": item.cantidad_unidad,
                    "actual": item.actual,
                    "inventario":  "$" + Math.trunc(inventario).toLocaleString("es-CL")
                };
            });
        doc.autoTable(columns, tabla, {
            margin: { top: 100 },
            columnStyles: {
                cantidad_unidad: { halign: "center" }
            }
        });
        doc.save('Informe_Tipo_Insumo_' + nombre_tipo + '_' + date);

    },
    exportToPdfProveedorInsumo(insumos, nombre_proveedor){
        //Se genera el documento
        var doc = new jsPDF('p','pt');

        //Se inserta el logo
        var img = new Image();
        img.src = require("@/assets/logos/Logo.png");
        doc.addImage(img, "png", 0, 7, 142, 70);

        //Se inserta titulo
        const date = conv.formatFecha(Date.now());
        doc.text('Informe: '+nombre_proveedor, 220, 90);

        //Se inserta fecha
        doc.setFontSize(8);
        doc.text(conv.formatFecha(Date.now()), 58, 85);

        var columns = [
            {title: "Insumo", dataKey: "insumo"},
            {title: "Unidad", dataKey: "unidad_venta"},
            {title: "Tipo", dataKey: "tipo"},
            {title: "Precio Neto", dataKey: "precio_neto"},
            {title: "Precio Bruto", dataKey: "precio_bruto"},
            {title: "Pedido", dataKey: "unidad_pedido"},
            {title: "Cantidad", dataKey: "cantidad_unidad"}
        ];
        var tabla = insumos
            .map(function(item) {
                return {
                    "insumo": item.nombre,
                    "unidad_venta": item.unidad_venta,
                    "tipo": item.tipo,
                    "precio_neto": item.providers[0].precio_neto,
                    "precio_bruto": item.providers[0].precio_bruto,
                    "unidad_pedido": item.unidad_pedido,
                    "cantidad_unidad": item.cantidad_unidad
                };
            });
        doc.autoTable(columns, tabla, {margin: {top: 100},});
        doc.save('Informe_Proveedor_Insumo_' + nombre_proveedor + '_' + date);

    },
    async exportToPdfPlato(plato){
        //Se genera el documento
        var doc = new jsPDF('p','pt');

        //Se inserta el logo
        var img = new Image();
        img.src = require("@/assets/logos/Logo.png");
        doc.addImage(img, "png", 0, 7, 142, 70);

        //Se inserta titulo
        const date = conv.formatFecha(Date.now());
        doc.text('Detalles de plato: '+plato.nombre, 200, 90);

        //Se inserta fecha
        doc.setFontSize(8);
        doc.text(conv.formatFecha(Date.now()), 58, 85);

        function convertRecetaToArray(recetaHTML) {
            const div = document.createElement("div");
            div.innerHTML = recetaHTML;
            const lines = [];
            div.childNodes.forEach((node) => {
                if (node.nodeType === 1) {
                    lines.push(node.innerText.trim());
                }
            });
            return lines;
        }
    

        const recetaLines = convertRecetaToArray(plato.receta);
    
        var columns = [
            { title: "Tipo", dataKey: "tipo",  width: 20 },
            { title: "Costo", dataKey: "costo",  width: 20 },
        ];

        var tabla_tipo = [{
            "tipo": plato.tipo,
            "costo": plato.costo,
          }];
     
        doc.autoTable(columns, tabla_tipo, {
            margin: {top: 100, left: 40, right: 40},
            headerStyle:{fillColor: [139, 0, 0], fontSize: 8},
            columnStyles: {
                0: { cellWidth: 64 },
                1: { cellWidth: 64 },
            }
        });

        var tabla_ingredientes = plato.supplies
            .map(function(item) {
                return {
                    "supply": item.supply.nombre,
                    "quantity_supply": item.quantity_supply,
                    "unidad_cantidad": item.unidad_cantidad,
                };
        });
        var listaIngredientes = tabla_ingredientes.map(function(item) {
            return [
                item.supply,
                item.quantity_supply,
                item.unidad_cantidad
            ];
        });
        function generarListaDeIngredientes(ingredientes) {
            var lista = "";
            for (var i = 0; i < ingredientes.length; i++) {
                lista += "Ingrediente " + (i + 1) + ":\n";
                lista += " - Suministro: " + ingredientes[i][0] + "\n";
                lista += " - Cantidad: " + ingredientes[i][1] + " " + ingredientes[i][2] + "\n\n";
            }
            return lista;
        }


        var tabla_data = [{
            "receta": recetaLines.join("\n"),
            "supplies": generarListaDeIngredientes(listaIngredientes)
        }];

        var columnas = [
            { title: "Suministros", dataKey: "supplies" },
            { title: "Receta", dataKey: "receta" },
        ];

        var options = {
            margin: { top: 100, left: 40, right: 40 },
            columnStyles: {
              receta: { columnWidth: 200 },
            },
        };

        doc.autoTable(columnas, tabla_data, options);
        doc.save('Detalles_Plato_' + plato.nombre + '_' + date);

    },
    exportToPdfRangoMenu(menus){
        console.log(menus);
        //Se genera el documento
        var doc = new jsPDF('p','pt');

        //Se inserta el logo
        var img = new Image();
        img.src = require("@/assets/logos/Logo.png");
        doc.addImage(img, "png", 0, 7, 142, 70);

        var fechaInicial = menus.length > 0 ? menus[0].fecha.split('T')[0] : '';
        var fechaFinal = menus.length > 0 ? menus[menus.length - 1].fecha.split('T')[0] : '';

        //Se inserta titulo
        doc.text('Menus desde '+ conv.formatFecha(fechaInicial) + " - " + conv.formatFecha(fechaFinal) , 180, 90);

        //Se inserta fecha
        doc.setFontSize(8);
        doc.text(conv.formatFecha(Date.now()), 58, 85);

        var columns = [
            {title: "Menú", dataKey: "tipo"},
            {title: "Tipo Plato", dataKey: "tipo_plato"},
            {title: "Platos", dataKey: "dishes"},
        ];


        var tabla_data = [];
        var fechaActual = null;
        var caso1= 0;
        var platos = [];
        var tipo_plato = [];
        var currentY = 140;

        var options = {
            startY: currentY,
            margin: { top: 100, left: 40, right: 40 },
            columnStyles: {
                tipo_plato: { columnWidth: 150},
                dishes: { columnWidth: 250 },
            },
        };


        menus.forEach(function (item, index) {
            var fechaItem = item.fecha.split('T')[0];
            var fecha_buena = conv.formatFecha(fechaItem);
            if (fechaItem !== fechaActual) {
                if(caso1!=0){
                    doc.autoTable(columns, tabla_data,{
                        startY: currentY,  
                        margin: { left: options.margin.left, right: options.margin.right },
                        columnStyles: {  tipo_plato: { columnWidth: 150}, dishes: { columnWidth: 250 }},});
                    currentY = doc.autoTable.previous.finalY+20;
                    tabla_data = [];
                }

                 // Ajustar el estilo del título de la fecha
                doc.setFontSize(14);
                doc.text('Fecha: ' + fecha_buena, 220, currentY);
                currentY += 14;


                platos = item.dishes.map(function(dish) {
                    return dish.dish.nombre;
                });
                tipo_plato = item.dishes.map(function(dish){
                    return dish.option_plato + ': '
                })
                tabla_data.push({
                    "tipo": item.tipo,
                    "tipo_plato": tipo_plato.join('\n'),
                    "dishes": platos.join('\n'), // Concatenar los platos en una cadena
                });
                if(index === menus.length-1){
                    doc.autoTable(columns, tabla_data, {
                        startY: currentY,  
                        margin: { left: options.margin.left, right: options.margin.right },
                        columnStyles: { tipo_plato: { columnWidth: 150}, dishes: { columnWidth: 250 }},});
                    currentY = doc.autoTable.previous.finalY+10;
                }
                caso1=1;
                fechaActual = fechaItem;

            }else {
                platos = item.dishes.map(function(dish) {
                    return dish.dish.nombre;
                });
                tipo_plato = item.dishes.map(function(dish){
                    return dish.option_plato + ': '
                })
                tabla_data.push({
                    "tipo": item.tipo,
                    "tipo_plato": tipo_plato.join('\n'),
                    "dishes": platos.join('\n'), // Concatenar los platos en una cadena
                });
                if(index === menus.length-1){
                    doc.autoTable(columns, tabla_data, {
                        startY: currentY,  
                        margin: { left: options.margin.left, right: options.margin.right },
                        columnStyles: { tipo_plato: { columnWidth: 150}, dishes: { columnWidth: 250 }},});
                    currentY = doc.autoTable.previous.finalY+10;
                }
            }
        });

        doc.save('Menus_desde_'+ conv.formatFecha(fechaInicial) + "-" + conv.formatFecha(fechaFinal));
    },
    exportToPdfRopas(entregas, fecha_limite, total) {
        const doc = new jsPDF("p", "pt");

        /* ================= LOGO ================= */
        const img = new Image();
        img.src = require("@/assets/logos/Logo.png");
        doc.addImage(img, "PNG", 40, 20, 120, 60);

        /* ================= TITULO ================= */
        doc.setFontSize(16);
        doc.setFont("helvetica", "bold");
        doc.text("REPORTE DE ROPA POR FECHA", 300, 45, { align: "center" });

        /* ================= INFO ================= */
        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");

        // usando tu helper conv (ajusta el nombre si es distinto)
        const fechaFormateada = conv.fechaCL
            ? conv.fechaCL(fecha_limite)
            : new Date(fecha_limite).toLocaleDateString("es-CL");
        console.log(fecha_limite);
        console.log(fechaFormateada);
        doc.text(`Fecha límite: ${fechaFormateada}`, 40, 95);
        doc.text(`Total de registros: ${total}`, 40, 110);

        let ultimoTipoRopa = null;

        /* ================= TABLA ================= */
        doc.autoTable({
            startY: 130,
            head: [[
                "Tipo de Ropa",
                "Stock",
                "Sexo",
                "Talla",
                "Cantidad"
            ]],
            body: entregas.map(e => {
                const mostrarStock = e.tipo_ropa !== ultimoTipoRopa;
                ultimoTipoRopa = e.tipo_ropa;

                return [
                    e.tipo_ropa,
                    mostrarStock ? e.stock : "", // 👈 lógica clave
                    e.sexo,
                    e.talla,
                    e.cantidad
                ];
            }),
            styles: {
                fontSize: 9,
                halign: "center",
                valign: "middle"
            },
            headStyles: {
                fillColor: [27, 27, 27],
                textColor: 255,
                fontStyle: "bold"
            },
            columnStyles: {
                0: { halign: "left" }, // tipo de ropa alineado a la izquierda
                1: { halign: "center" }, // Stock
                2: { halign: "center" }, // Sexo
                3: { halign: "center" }, // Talla
                4: { halign: "center" }  // Cantidad
            }
        });

        /* ================= FOOTER ================= */
        const pageCount = doc.internal.getNumberOfPages();

        for (let i = 1; i <= pageCount; i++) {
            doc.setPage(i);
            doc.setFontSize(8);
            doc.text(
                `Página ${i} de ${pageCount}`,
                doc.internal.pageSize.width / 2,
                doc.internal.pageSize.height - 20,
                { align: "center" }
            );
        }

        /* ================= DESCARGA ================= */
        doc.save(`reporte_ropa_${fechaFormateada}.pdf`);
    },
    exportToPdfHistorialCamas(camas, fecha, turno) {
        const doc = new jsPDF("p", "pt");

        /* ================= LOGO ================= */
        const img = new Image();
        img.src = require("@/assets/logos/Logo.png");
        doc.addImage(img, "PNG", 40, 20, 120, 60);

        /* ================= TITULO ================= */
        doc.setFontSize(13);
        doc.setFont("helvetica", "bold");
        doc.text(
            `HISTORIAL DIARIO DE CAMAS – TURNO ${turno}`,
            doc.internal.pageSize.width / 2,
            70,
            { align: "center" }
        );

        /* ================= INFO ================= */
        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");

        const fechaFormateada = conv?.fechaCL
            ? conv.fechaCL(fecha)
            : new Date(fecha).toLocaleDateString("es-CL");

        doc.text(`Fecha: ${fechaFormateada}`, 40, 95);
        doc.text(`Total de camas: ${camas.length}`, 40, 110);

        /* ================= TABLA ================= */
        doc.autoTable({
            startY: 130,
            head: [[
                "Habitación",
                "Lado",
                "Estado",
                "Cliente",
                "Turno",
                "Grupo"
            ]],
            body: camas.map(cama => [
                cama.room_numero_hab,
                cama.lado,
                cama.estado,
                cama.cliente
                    ? `${cama.cliente.name} ${cama.cliente.f_lastname} ${cama.cliente.m_lastname || ""}`
                    : "",
                cama.cliente?.turno || "",
                cama.cliente?.grupo || ""
            ]),
            styles: {
                fontSize: 9,
                halign: "center",
                valign: "middle"
            },
            headStyles: {
                fillColor: [27, 27, 27],
                textColor: 255,
                fontStyle: "bold"
            },
            columnStyles: {
                0: { halign: "center" }, // Hab
                1: { halign: "center" }, // Lado
                2: { halign: "center" }, // Estado
                3: { halign: "left" },   // Cliente
                4: { halign: "center" }, // Turno
                5: { halign: "center" }  // Grupo
            }
        });

        /* ================= FOOTER ================= */
        const pageCount = doc.internal.getNumberOfPages();

        for (let i = 1; i <= pageCount; i++) {
            doc.setPage(i);
            doc.setFontSize(8);
            doc.text(
                `Página ${i} de ${pageCount}`,
                doc.internal.pageSize.width / 2,
                doc.internal.pageSize.height - 20,
                { align: "center" }
            );
        }

        /* ================= DESCARGA ================= */
        doc.save(`historial_camas_${fechaFormateada}_turno_${turno}.pdf`);
    },
    exportToPdfTiposInsumosyPrecio(tipos_insumos) {
        const doc = new jsPDF("p", "pt");

        /* ================= LOGO ================= */
        const img = new Image();
        img.src = require("@/assets/logos/Logo.png");
        doc.addImage(img, "PNG", 40, 20, 120, 60);

        /* ================= TITULO ================= */
        doc.setFontSize(13);
        doc.setFont("helvetica", "bold");

        const date = conv.formatFecha(Date.now());


        doc.text("Totales por Tipo de Insumo", 300, 55, { align: "center" });

        
        //Se inserta fecha
        doc.setFontSize(8);
        doc.text(conv.formatFecha(Date.now()), 84, 85);

        /* ================= INFO ================= */
        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");


        /* ================= TABLA ================= */
        /* ================= TABLA ================= */
        var columns = [
            { title: "Tipo Insumo", dataKey: "tipo" },
            { title: "Total Neto (CLP)", dataKey: "total" }
        ];

        let totalGeneral = 0;

        var lista_tipos = tipos_insumos.map(function (item) {
            const totalNumero = Math.trunc(Number(item.total) || 0);
            totalGeneral += totalNumero;

            return {
                tipo: item.tipo,
                total: `$${totalNumero.toLocaleString("es-CL", {minimumFractionDigits: 0,maximumFractionDigits: 0})}`
            };
        });

        // agregar fila final
        lista_tipos.push({
            tipo: "TOTAL",
            total: `$${totalGeneral.toLocaleString("es-CL", {minimumFractionDigits: 0,maximumFractionDigits: 0})}`
        });

        doc.autoTable(columns, lista_tipos, {
            margin: { top: 120 },
            headStyles: { halign: "center" },
            columnStyles: {
                tipo: { halign: "center" },
                total: { halign: "center" }
            },
            didParseCell: function (data) {
                // si es la última fila (TOTAL)
                if (data.row.index === lista_tipos.length - 1) {
                    data.cell.styles.fontStyle = "bold";
                    data.cell.styles.textColor = [0, 0, 0]; // negro fuerte
                }
            }
        });

        doc.save('totales_por_tipo_insumo_'+date);
                
    },
    exportToPdfPlatosporInsumo(platos,insumoId, nombre_insumo) {
        const doc = new jsPDF("p", "pt");

        /* ================= LOGO ================= */
        const img = new Image();
        img.src = require("@/assets/logos/Logo.png");
        doc.addImage(img, "PNG", 40, 20, 120, 60);

        /* ================= TITULO ================= */
        doc.setFontSize(13);
        doc.setFont("helvetica", "bold");

        const date = conv.formatFecha(Date.now());


        doc.text("Platos que tiene el insumo: " + nombre_insumo, 300, 55, { align: "center" });

        
        //Se inserta fecha
        doc.setFontSize(8);
        doc.text(conv.formatFecha(Date.now()), 84, 85);

        /* ================= INFO ================= */
        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");


        /* ================= TABLA ================= */
        /* ================= TABLA ================= */
        const columns = [
            { title: "Plato", dataKey: "plato" },
            { title: "Cantidad", dataKey: "cantidad" }
        ];

        const tabla = platos.map((dish) => {
            const supplyEncontrado = dish.supplies.find(
            (s) => s.supply.toString() === insumoId.toString()
            );

            const cantidadTexto = supplyEncontrado
                ? `${supplyEncontrado.quantity_supply} ${supplyEncontrado.unidad_cantidad}`
                : "";

            return {
                plato: dish.nombre,
                cantidad: cantidadTexto
            };
        });

        doc.autoTable(columns, tabla, {
            margin: { top: 110 }
        });

        
        doc.save(`Platos_por_insumo_${nombre_insumo}_${date}.pdf`);
                
    },
    exportToPdfVariacionPrecios(insumos, proveedores, tipo, porcentaje) {
        var doc = new jsPDF('p', 'pt');

        // =========================
        // LOGO
        // =========================

        var img = new Image();
        img.src = require("@/assets/logos/Logo.png");
        doc.addImage(img, "png", 0, 7, 142, 70);


        // =========================
        // FECHA DEL INFORME
        // =========================

        doc.setFontSize(8);
        doc.text(
            conv.formatFecha(Date.now()),
            58,
            85
        );


        // =========================
        // VALIDAR FILTROS
        // =========================

        const tieneTipo =
            tipo !== null &&
            tipo !== undefined &&
            tipo !== '';

        const tienePorcentaje =
            porcentaje !== null &&
            porcentaje !== undefined &&
            porcentaje !== '';


        // =========================
        // TÍTULO
        // =========================

        let titulo = 'Informe de Insumos';

        if (tieneTipo && tienePorcentaje) {

            titulo = `Insumos por ${tipo} y ${porcentaje}%`;

        } else if (tieneTipo) {

            titulo = `Insumos por ${tipo}`;

        } else if (tienePorcentaje) {

            titulo = `Insumos con variación de ${porcentaje}%`;
        }


        doc.setFontSize(13);

        doc.text(
            titulo,
            doc.internal.pageSize.getWidth() / 2,
            90,
            {
                align: 'center'
            }
        );


        // =========================
        // FUNCIONES AUXILIARES
        // =========================

        const formatearFecha = (fecha) => {

            if (!fecha) {
                return '-';
            }

            const date = new Date(fecha);

            const dia = String(
                date.getDate()
            ).padStart(2, '0');

            const mes = String(
                date.getMonth() + 1
            ).padStart(2, '0');

            const anio = date.getFullYear();

            return `${dia}/${mes}/${anio}`;
        };


        const formatearPrecio = (precio) => {

            if (
                precio === null ||
                precio === undefined
            ) {
                return '-';
            }

            return `$${Number(precio).toLocaleString('es-CL')}`;
        };


        const getNombreProveedor = (id) => {

            const proveedor = proveedores.find(
                item =>
                    item._id.toString() ===
                    id.toString()
            );

            return proveedor
                ? proveedor.nombre
                : 'Sin proveedor';
        };


        // =========================
        // COLUMNAS
        // =========================

        let columns = [];


        // Si NO se eligió tipo,
        // mostramos una columna adicional
        if (!tieneTipo) {

            columns.push({
                title: 'Tipo',
                dataKey: 'tipo'
            });
        }


        columns.push(
            {
                title: 'Insumo',
                dataKey: 'insumo'
            },
            {
                title: 'Proveedor',
                dataKey: 'proveedor'
            },
            {
                title: 'P. Bruto Anterior',
                dataKey: 'precio_anterior'
            },
            {
                title: 'Fecha Anterior',
                dataKey: 'fecha_anterior'
            },
            {
                title: 'P. Bruto Actual',
                dataKey: 'precio_actual'
            },
            {
                title: 'Fecha Actual',
                dataKey: 'fecha_actual'
            },
            {
                title: '% Var.',
                dataKey: 'variacion'
            }
        );


        // =========================
        // CREAR FILAS
        // =========================

        const tabla = insumos.map(item => {

            // PROVEEDORES
            const proveedoresNombres = item.providers
                .map(prov =>
                    getNombreProveedor(
                        prov.provider
                    )
                )
                .join('\n');


            // PRECIOS ANTERIORES
            const preciosAnteriores = item.providers
                .map(prov =>
                    formatearPrecio(
                        prov.precio_bruto_anterior
                    )
                )
                .join('\n');


            // FECHAS ANTERIORES
            const fechasAnteriores = item.providers
                .map(prov =>
                    formatearFecha(
                        prov.fecha_anterior
                    )
                )
                .join('\n');


            // PRECIOS ACTUALES
            const preciosActuales = item.providers
                .map(prov =>
                    formatearPrecio(
                        prov.precio_bruto
                    )
                )
                .join('\n');


            // FECHAS ACTUALES
            const fechasActuales = item.providers
                .map(prov =>
                    formatearFecha(
                        prov.fecha_precio_actual
                    )
                )
                .join('\n');


            // VARIACIÓN PORCENTUAL
            const variaciones = item.providers
                .map(prov => {

                    if (
                        prov.variacion_porcentaje === null ||
                        prov.variacion_porcentaje === undefined
                    ) {
                        return '-';
                    }

                    const variacion =
                        Number(
                            prov.variacion_porcentaje
                        );

                    return `${
                        variacion > 0 ? '+' : ''
                    }${variacion.toFixed(2)}%`;
                })
                .join('\n');


            return {
                tipo: item.tipo,
                insumo: item.nombre,
                proveedor: proveedoresNombres,
                precio_anterior: preciosAnteriores,
                fecha_anterior: fechasAnteriores,
                precio_actual: preciosActuales,
                fecha_actual: fechasActuales,
                variacion: variaciones
            };
        });


        // =========================
        // ANCHOS DE COLUMNAS
        // =========================

        const columnStyles = tieneTipo
            ? {

                // Cuando ya filtramos por tipo
                // son 7 columnas

                insumo: {
                    cellWidth: 105
                },

                proveedor: {
                    cellWidth: 85
                },

                precio_anterior: {
                    cellWidth: 70,
                    halign: 'center'
                },

                fecha_anterior: {
                    cellWidth: 65,
                    halign: 'center'
                },

                precio_actual: {
                    cellWidth: 70,
                    halign: 'center'
                },

                fecha_actual: {
                    cellWidth: 65,
                    halign: 'center'
                },

                variacion: {
                    cellWidth: 55,
                    halign: 'center'
                }

            }
            : {

                // Cuando NO se filtra por tipo
                // agregamos la octava columna

                tipo: {
                    cellWidth: 60
                },

                insumo: {
                    cellWidth: 90
                },

                proveedor: {
                    cellWidth: 75
                },

                precio_anterior: {
                    cellWidth: 65,
                    halign: 'center'
                },

                fecha_anterior: {
                    cellWidth: 60,
                    halign: 'center'
                },

                precio_actual: {
                    cellWidth: 65,
                    halign: 'center'
                },

                fecha_actual: {
                    cellWidth: 60,
                    halign: 'center'
                },

                variacion: {
                    cellWidth: 50,
                    halign: 'center'
                }
            };


        // =========================
        // TABLA
        // =========================

        doc.autoTable(
            columns,
            tabla,
            {
                margin: {
                    top: 105,
                    left: 40,
                    right: 40
                },

                tableWidth: 'auto',

                styles: {
                    fontSize: 6,
                    cellPadding: 1.5,
                    valign: 'middle',
                    overflow: 'linebreak'
                },

                headerStyles: {
                    fontSize: 6,
                    halign: 'center',
                    valign: 'middle'
                },

                columnStyles: columnStyles
            }
        );


        // =========================
        // GUARDAR PDF
        // =========================

        let nombreArchivo = 'variacion_precios';

        if (tieneTipo) {
            nombreArchivo += `_${tipo}`;
        }

        if (tienePorcentaje) {
            nombreArchivo += `_${porcentaje}porc`;
        }

        doc.save(
            `${nombreArchivo}.pdf`
        );
    },


    /*
    async exportToPdf(){
        let response
        response = await axios.get('http://143.198.136.145:8080/Cliente/apellidos');
        this.clientsABC = response.data;
        console.log(this.clientesABC);
        var vm = this;
        const date = this.currentDate();
        var columns = [
            {title: "Nombre", dataKey: "nombre"},
            {title: "Apellido Paterno", dataKey: "apellidoPaterno"},
            {title: "Apellido Materno", dataKey: "apellidoMaterno"},
            {title: "Turno", dataKey: "turno"},
            {title: "Grupo", dataKey: "grupo"},
            {title: "Cargo", dataKey: "cargo"},
        ];
        var doc = new jsPDF('p','pt');
        doc.text('Lista de Clientes '+ date, 40, 40);
        doc.autoTable(columns, vm.clientsABC, {margin: {top: 60},});
        doc.save('Lista_Clientes_' + date);

    },
    async exportToPdf(){
        let roomLen = this.rooms.length;
        let i =0;
        let res;  
        while(i < roomLen){         
            let res;
            res = await axios.get('http://143.198.136.145:8080/Cama/camasId/'+ this.rooms[i].id);
            this.camas = res.data;
            if(this.camas.length == 1){
                this.pdfData.push({
                    numero: this.rooms[i].numero,
                    tipo: this.rooms[i].tipo,
                    inventario: this.rooms[i].inventario,
                    tipos_camas: [this.camas[0].tipo]
                });
            }else{
                this.pdfData.push({
                    numero: this.rooms[i].numero,
                    tipo: this.rooms[i].tipo,
                    inventario: this.rooms[i].inventario,
                    tipos_camas: [this.camas[0].tipo, this.camas[1].tipo]
                });
            }         
            i++;
        }

        var vm = this;
        const date = this.currentDate();
        var columns = [
            {title: "Numero", dataKey: "numero"},
            {title: "Tipo", dataKey: "tipo"},
            {title: "Inventario", dataKey: "inventario"},
            {title: "Tipo de Camas", dataKey: "tipos_camas"},
        ];
        var doc = new jsPDF('p','pt');
        doc.text('Lista de Habitaciones '+ date, 40, 40);
        doc.autoTable(columns, vm.pdfData, {margin: {top: 60},});
        doc.save('Lista_Habitaciones_' + date);

    },
    */
}